import { Typography } from '@mui/material';
import styled from 'styled-components';
import { useModalStore } from 'src/stores/ModalStore';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top:24px;
`

export default function AdModalBasic() {
  const modalTitle = useModalStore((state)=>state.title)
  const modalContent = useModalStore((state)=>state.content)
  const modalFooter = useModalStore((state)=>state.footer)
  
  return (
    <>
      <Typography variant="h6" style={{display:'flex' ,justifyContent:'flex-start', fontSize:'24px',fontWeight:600}}>
        {modalTitle}
      </Typography>
      <Typography sx={{ mt: '12px' }}>
        {modalContent}
      </Typography>
      <ButtonWrapper>
        {modalFooter}
      </ButtonWrapper>
    </>
  );
}